//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/BaseImporter.js";
let d=[[[0,"FileOpenFlag",1,0],[0,"ImportTo",1,0],[0,"ImportToTeamcenter",1,0],[0,"IncludeHiddenEntities",1,0],[0,"Messages",1,0],[0,"Optimize",1,0],[0,"SettingsFile",1,0],[0,"ShowInformationWindowFlag",1,0],[0,"SimplifyGeometry",1,0],[0,"Solids",1,0],[0,"Surfaces",1,0]],[[["filename"],"SaveSettings",{},1,0]],[]];
SPLM.InventorImporter = class extends SPLM.BaseImporter{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.InventorImporter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.InventorImporter.ImportToOption = Object.freeze({
    "WorkPart" : "WorkPart", "NewPart" : "NewPart"});

SPLM.InventorImporter.MessageEnum = Object.freeze({
    "None" : "None", "Informational" : "Informational", "Warning" : "Warning", "Error" : "Error", "Debug" : "Debug", "All" : "All"});

export default SPLM;